<template>
  <div class="p-6 flex">
    <div
      v-if="icon"
      class="w-10 h-10 mr-4 rounded-md text-secondary flex justify-center items-center border border-secondary"
    >
      <Icon :type="icon" />
    </div>
    <div>
      <div class="text-xl font-semibold">{{ title }}</div>
      <div
        v-if="description"
        class="text-sm"
      >
        {{ description }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icon/Icon.vue'

defineProps({
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: null
  }
})
</script>
